/** Loads every `ui/*.ui.ts` (each registers itself: ui/registry.ts) and mounts them. */
import { mountRegisteredUis, type UiContext, type UiPart } from './registry';

import.meta.glob('./*.ui.ts', { eager: true });

export function mountUis(ctx: UiContext): UiPart[] {
  return mountRegisteredUis(ctx);
}
